import { Chart } from "chart.js";
import { onResize } from "./chartJsPlugins";
import { getContrastColor } from './configs';

    // @ts-ignore
window.initOstFundingBlock = function (blockId, config, data) {
    console.log('ost data', data)
    const total_awarded_funds = document.getElementById('total_awarded_funds');

    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const formatValue = (v) => v;
    const formatLabel = (v) => v;

    const values = data.map(item => formatValue(item.TotalAward));
    const labels = data.map(item => formatLabel(item.SchoolYear))

    // chartjs-plugin-datalabels mispositions in-bar labels on horizontal bar charts
    // under Chart.js v4, so draw the award amounts directly on the canvas instead.
    const awardLabels = {
        id: 'awardLabels',
        afterDatasetsDraw(chart) {
            const { ctx } = chart;
            ctx.save();
            ctx.font = chart.width > 505
                ? '500 14px "Roboto", Roboto, Arial, sans-serif'
                : '500 10px "Roboto", Roboto, Arial, sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            chart.data.datasets.forEach((dataset, datasetIndex) => {
                if (!chart.isDatasetVisible(datasetIndex)) return;

                chart.getDatasetMeta(datasetIndex).data.forEach((meta: any, i) => {
                    const value = dataset.data[i];
                    if (value == null || isNaN(value as number)) return;

                    const text = currency.format(value as number).replace('.00', '');
                    const xBase = typeof meta.base === 'number'
                        ? meta.base
                        : (chart.scales.x as any).getPixelForValue(0);

                    // skip when the bar is too narrow to hold the label
                    if (Math.abs(meta.x - xBase) < ctx.measureText(text).width + 8) return;

                    const bgColor = (Array.isArray(dataset.backgroundColor)
                        ? dataset.backgroundColor[i]
                        : dataset.backgroundColor) as string;
                    ctx.fillStyle = getContrastColor(bgColor ?? '#ffffff');
                    ctx.fillText(text, (meta.x + xBase) / 2, meta.y);
                });
            });

            ctx.restore();
        }
    };

    // @ts-ignore
    new Chart(total_awarded_funds, {
        type: 'bar',
        data: {
            //labels: ['2021', '2022', '2023'],
            labels: labels,
            datasets: [{
                label: "Test",
                //data: [190, 155, 130],
                data: values,
                backgroundColor: ['#621E71', '#8B2BA1', '#EAD9EE']
            }]
        },
        options: {
            indexAxis: 'y',
            categoryPercentage: 1,
            maintainAspectRatio: false,
            onResize: onResize,
            scales: {
                x: {
                    grid: {
                        display: true,
                        color: '#DDE0E7'
                    },
                    border: {
                        dash: [5, 5]
                    },
                    beginAtZero: true,
                    min: 0,
                    //max: 500,
                    ticks: {
                        stepSize: 50*1000,
                        callback: (value, index, values) => {
                            return `$` + (''+value).slice(0,-3) + `K`;
                        }
                    },
                    title: {
                        display: true,
                        text: 'Total Awarded Funds ($)',
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: "School Year",
                    },
                    grid: {
                        display: false
                    }
                }
            },
            plugins: {
                legend: {
                    display: false,
                    position: 'top',
                    labels: {
                        font: {
                            size: 16
                        }
                    }
                },
                tooltip: {
                    enabled: false
                }
            }
        },
        plugins: [awardLabels]

    });
}